<onyx-data-widget
  [supheading]="`${DictionaryCode.RATE_TYPE}.${order().basicInformation.rateType}`"
  [headingIcon]="{ name: 'finance-filled', size: 20, color: 'black' }"
>
  <div heading class="order-price">
    <span
      [innerHTML]="
        order().price.defaultCurrencyValue / 100
          | number: '1.2-2'
          | numberDecoration
            : { unit: (order().price.defaultCurrency | uppercase) }
      "
      [onyxTooltip]="clearingTooltip"
      onyxTooltipColor="white"
    ></span>

    <span class="f-muted f-body-m f-semibold"
      >+{{ 'labels.vat' | translate }}</span
    >
  </div>

  <div class="list">
    <div class="item">
      <p class="f-muted">{{ 'labels.loadedKilometerRate' | translate }}</p>

      <span class="rate">
        <app-amount-cell
          [amount]="kmRate()"
          show="defaultCurrency"
          [short]="false"
        ></app-amount-cell>
        /km
      </span>
    </div>

    <div class="item">
      <p class="f-muted">{{ 'labels.dailyIncome' | translate }}</p>

      <span>
        <app-amount-cell
          [amount]="dailyRate()"
          show="defaultCurrency"
          [short]="false"
        ></app-amount-cell>
      </span>
    </div>
  </div>
</onyx-data-widget>

<ng-template #clearingTooltip>
  <div class="tooltip">
    <onyx-table
      [columns]="ORDER_MODAL_PLAN_FINANCES_COLUMNS"
      [data]="settlementData()"
      [tableShadow]="false"
    ></onyx-table>

    @let rateDate = order().price.date;
    @if (settlementData().length > 1 && rateDate) {
      <span class="f-muted">
        {{ 'labels.nbpRate' | translate }}:
        {{ rateDate | onyxDate: 'date-dot' }}
      </span>
    }
  </div>
</ng-template>
